import type { Currency } from 'types/account';

export const currencyFactory = (currency?: Partial<Currency>): Currency => {
  return {
    id: 'usd',
    iso_code: 'USD',
    name: 'United States Dollar',
    symbol: '$',
    symbol_first: true,
    ...currency,
  };
};
